import React from "react";
import Fab from "@material-ui/core/Fab";

const PortfolioLanding = () => {
  return (
    <div id="home" className="view jarallax portfolio-landing">
      <div className="mask rgba-white-slight">
        <div className="container h-100 d-flex justify-content-center align-items-center">
          <div className="row smooth-scroll justify-content-center align-items-center">
            <div className="col-md-12 pt-3 text-center">
              <div className="pt-5">
                <h1 className="display-2 mb-4" style={{ color: "#c89a69" }}>
                  I am{" "}
                  <strong style={{ fontWeight: "bolder" }}>
                    Ashwanee Gupta
                  </strong>
                </h1>

                <h5 className="text-uppercase font-weight-bold">
                  <mark>Web developer & Graphic designer</mark>
                </h5>
                <div className="portfolio_btn hvr-wobble-vertical mt-3 pt-3 hvr-icon-wobble-vertical">
                  <Fab variant="extended" href="#about" aria-label="getStarted">
                    <i
                      className="fa fa-arrow-down hvr-icon"
                      aria-hidden="true"
                    ></i>
                  </Fab>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioLanding;
